import React, { useEffect, useState } from 'react';
import LargePopup from 'components/popup/large-popup';
import styled from 'styled-components';
import accountIcon from "images/account-icon.png";
import { propsToJS } from '__utils/immutable-to-js';
import { useDispatch, useSelector } from 'react-redux';
import LoginSelector from './login.selector';
import { ClickableSpan, FormErrorMessageSpan, FormField } from 'views/common-styled-components';
import * as LoginActions from './login.actions';
import { getNonNullDefinedObject, isProUser, redirectToHome, redirectToOld } from '__utils/common-utils';
import { useMediaQuery } from 'react-responsive';
import { useForm } from 'react-hook-form';
import { COLOR } from 'constants/colors';
import { SuccessButton } from 'components/button';
import elementVisibility from '__utils/toggleVisibilty-util';
import logo1 from "images/logo1.png";
import useFlashToggler from 'hooks/use-flash-toggler';
import { CommonStyledComponentProps } from '__utils/type';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import LoginCustomerRadio from './loginCustomerRadio';
import loader from '__utils/loader-util';

const LoginMainContDiv = styled.div`
    display: none;
    .cls{
        
    }
    input{
        font-size: 14px;
    }
    input::-webkit-input-placeholder{
        font-size:14px !important;
        color: #96a9bb;
    }
`;

const LoginOuterCont = styled.div<CommonStyledComponentProps>`
    background-color: ${COLOR.GREY_BG};
    // margin-top: ${isProUser() ? '-20px' : '0'};
    height: ${(props: CommonStyledComponentProps) => props.isMobile ? `calc(100vh - 58px)` : `auto`};  
`;

const LoginContDiv = styled.div<CommonStyledComponentProps>`
    overflow: hidden;
    background-color: ${COLOR.WHITE};
    padding: ${(props: CommonStyledComponentProps) => props.isMobile ? "16px" : "0px"};
    border-radius: 5px;
   
`;

const LoginFormContainer = styled.div<CommonStyledComponentProps>`
    padding: ${(props: CommonStyledComponentProps) => props.isMobile ? "10px" : "50px 59px"};
    h4.text-center {
        margin-bottom: 30px;
    }
    h2 {
        margin-bottom: 40px;
    }
  
`;

const LoginUserIcon = styled.div`
    margin-bottom: 15px;
    text-align: center;
    float: left;
    width: 100%;
    img {
        width: 40px;
        height: 40px;
    }
`;

const LoginHeader = styled.h2<CommonStyledComponentProps>`
    font-size: 16px;
    font-weight: ${(props: CommonStyledComponentProps) => props.isMobile ? "500" : "400"};
    line-height: 1.33;
    text-align: center;
    color: #001837;
    margin-bottom: ${(props: CommonStyledComponentProps) => props.isMobile ? "30px" : "40px"};
`;

const LoginToolbox = styled.div<CommonStyledComponentProps>`
    padding: 25px ${(props: CommonStyledComponentProps) => props.isMobile ? "10px" : "60px"};
    padding-bottom: 25px ${(props: CommonStyledComponentProps) => props.isMobile ? "" : "40px"};
    font-size: 12px;
    font-weight: normal;
    text-align: center;
    color: #96a9bb;
    border-top: solid 1px #dfeef5;
`;
const LoginSuccessBtn = styled(SuccessButton) <CommonStyledComponentProps>`
    margin-top: ${(props: CommonStyledComponentProps) => props.isMobile ? "" : `10px`};
    &:disabled {
    color: #fff !important;
    background: ${(props: CommonStyledComponentProps) => props.isMobile ? "#9e9e9e !important" : `#e0e0e0 !important`};
    cursor: default ;
}
`;
const Login: React.FC = () => {

    const dispatch = useDispatch();
    const [passwordNotMatch, setPasswordNotMatch] = useState<boolean>(false);
    const [loginConfig, setLoginConfig] = useState<any>();
    const { signinStep, enteredWrongPassword, userMappedToOtherAgent, otpVerified, incorrectOtp, userPasswordNotPresent, currentUserDetails } = propsToJS(useSelector(LoginSelector));
    const { register, handleSubmit, formState, setValue, reset, getValues } = useForm({ mode: 'onChange' });
    const { errors } = formState;
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const flash = useFlashToggler();

    useEffect(() => {
        if (userMappedToOtherAgent) {
            flash.error("User mapped to other agent");
            dispatch(LoginActions.setUserMappedToOtherAgent(false));
        }
    }, [userMappedToOtherAgent, dispatch]);

    useEffect(() => {

        if (otpVerified) {
            if (signinStep === 'confirmpassword') {
                dispatch(LoginActions.fetchUserLogin(loginConfig.useremail, loginConfig.mobile, loginConfig.username, loginConfig.userpassword));
            } else if (signinStep === 'updatepassword') {
                dispatch(LoginActions.fetchUpdateUserPassword(loginConfig.mobile, loginConfig.userpassword));
            }
            dispatch(LoginActions.setOtpVerified(false));
        }

    }, [otpVerified, signinStep, loginConfig, dispatch]);


    useEffect(() => {
        if (userPasswordNotPresent && signinStep === 'updatepassword') {
            dispatch(LoginActions.fetchSendLoginOtp(loginConfig.mobile, 0));
        }
    }, [userPasswordNotPresent]);

    useEffect(() => {
        if (incorrectOtp?.wrongOtp) {
            flash.error("Please enter correct OTP.");
            dispatch(LoginActions.fetchVerifyLoginOtpError(''));
        }
        else if (incorrectOtp?.expired) {
            flash.error("Your OTP has expired. Please request a new OTP");
        }
    }, [incorrectOtp, dispatch]);

    const getLoginHeaderText = (): string => {
        switch (signinStep) {
            case 'mobile':
                return 'Login with your mobile number';
            case 'password':
                return 'Please enter your password';
            case 'userdetails':
                return 'Please enter your email and name';
            case 'confirmpassword':
                return 'Please enter OTP and new password';
            case 'updatepassword':
                return 'Please enter OTP and new password';
            case 'multipleUsers':
                return 'Choose the profile you want to access';
            default:
                return '';
        }
    }

    const onForgetPasswordClick = () => {
        dispatch(LoginActions.fetchSendLoginOtp(loginConfig.mobile, 1));
        dispatch(LoginActions.setSigninStep('updatepassword'));
        Mixpanel.track(getEventName("forgotPassword", "clicked", "loginSignup"));
    }

    const resendOtp = () => {
        dispatch(LoginActions.fetchSendLoginOtp(loginConfig.mobile, 0));
        Mixpanel.track(getEventName("resendOTP", "clicked", "loginSignup"));
    }

    const onLoginFormSubmit = (loginForm: any) => {
        if (loginForm.userpassword && loginForm.userconfirmpassword && loginForm.userpassword !== loginForm.userconfirmpassword) {
            setPasswordNotMatch(true);
        } else {
            if (signinStep === 'mobile') {
                dispatch(LoginActions.fetchGetCheckMobileNumber(loginForm.mobile));
                Mixpanel.track(getEventName("checkMobile", "clicked", "loginSignup"));
            } else if (signinStep === 'password') {
                dispatch(LoginActions.fetchVerifyPassword(loginConfig.mobile, loginForm.password));
                Mixpanel.track(getEventName("submitPassword", "clicked", "loginSignup"));
            } else if (signinStep === 'userdetails') {
                if(userPasswordNotPresent){ dispatch(LoginActions.fetchSendLoginOtp(loginConfig.mobile, 0))}
                dispatch(LoginActions.setSigninStep('confirmpassword'));
                Mixpanel.track(getEventName("sendOtp", "clicked", "loginSignup"));
            } else if (signinStep === 'confirmpassword' || signinStep === 'updatepassword') {
                dispatch(LoginActions.fetchVerifyLoginOtp(loginForm.otp, loginConfig.mobile));
                Mixpanel.track(getEventName("updatePassword", "clicked", "loginSignup"));
            }
            else if (signinStep === 'password' && userPasswordNotPresent) {
                dispatch(LoginActions.fetchUpdateUserPassword(loginConfig.mobile, loginConfig.userpassword));
            }
        }
        setLoginConfig({ ...loginConfig, ...getNonNullDefinedObject(loginForm) });
    }

    const onUserSelection = () => {
        const selectedUser = currentUserDetails.find((user:any)=>user?.tokenInfo?.user?.encryptedId === getValues('loginUser'));
        dispatch(LoginActions.fetchGetCurrentUserSuccess(selectedUser?.tokenInfo));
        dispatch(LoginActions.setSigninStep('mobile'));
        loader.show();
    }

    return (<LoginMainContDiv id="loginDiv">
        <LargePopup
            closable={true}
            headerContent={<div style={{ textAlign: 'center' }} onClick={() => redirectToHome()}><img alt="Turtlemint Money - Invest in best performing funds by consulting experts for free" src={logo1} style={{ height: '35px' }} /></div>}
            onClose={() => { reset(); dispatch(LoginActions.setSigninStep('mobile')); elementVisibility.hide('loginDiv') }}
        >   <LoginOuterCont isMobile={isMobile} className={isMobile ? " p16" : ""}>
                <LoginContDiv className={isMobile ? "mint-box mb16 p16" : ""} isMobile={isMobile}>
                    <section>
                        <LoginFormContainer isMobile={isMobile}>
                            <form name="loginForm" onSubmit={handleSubmit(onLoginFormSubmit)} noValidate>
                                <LoginUserIcon>
                                    <img src={accountIcon} alt={`Account`} />
                                </LoginUserIcon>
                                <LoginHeader isMobile={isMobile}>{getLoginHeaderText()}</LoginHeader>

                                {signinStep === 'mobile' || signinStep === 'userdetails' || signinStep === 'password' ? <FormField>
                                    <input
                                        name='mobile'
                                        type="number"
                                        placeholder="10 digit Mobile number"
                                        ref={register({
                                            required: "Please enter mobile number",
                                            pattern: {
                                                value: /^[6-9]{1}[0-9]{9}$/,
                                                message: "Please enter a valid mobile number"
                                            },
                                            minLength: {
                                                value: 10,
                                                message: "Please enter a valid mobile number"
                                            },
                                            maxLength: {
                                                value: 10,
                                                message: "Please enter a valid mobile number"
                                            }
                                        })}
                                        disabled={signinStep === 'userdetails' || signinStep === 'password'}
                                    />
                                    {errors.mobile ? <FormErrorMessageSpan style={{ marginTop: "2px", marginBottom: "10px" }}>{errors.mobile.message}</FormErrorMessageSpan> : null}
                                </FormField> : null}
                                {(signinStep === 'password' && !userPasswordNotPresent) ? <FormField>
                                    <input
                                        name='password'
                                        type="password"
                                        onChange={() => setPasswordNotMatch(false)}
                                        placeholder="Enter password"
                                        ref={register({ required: "Please enter password" })}
                                    />
                                    {errors.password ? <FormErrorMessageSpan style={{ marginTop: "2px", marginBottom: "10px" }}>{errors.password.message}</FormErrorMessageSpan> : null}
                                    {enteredWrongPassword ? <FormErrorMessageSpan style={{ marginTop: "2px", marginBottom: "10px" }}>Please enter correct password</FormErrorMessageSpan> : null}
                                </FormField> : null}
                                {signinStep === 'userdetails' ? <FormField>
                                    <input
                                        name='username'
                                        type="text"
                                        placeholder="Please enter name"
                                        ref={register({
                                            required: "Please enter name",
                                            pattern: {
                                                value: /^[a-zA-Z]+((['. -][a-zA-Z ])?[a-zA-Z]*)*$/,
                                                message: 'Please enter a valid name'
                                            }
                                        })}
                                    />
                                    {errors.username ? <FormErrorMessageSpan style={{ marginTop: "2px", marginBottom: "10px" }}>{errors.username.message}</FormErrorMessageSpan> : null}
                                </FormField> : null}
                                {signinStep === 'userdetails' ? <FormField>
                                    <input
                                        name='useremail'
                                        type="email"
                                        placeholder="Please enter email"
                                        ref={register({
                                            required: "Please enter email",
                                            pattern: {
                                                value: /^.+@[^.].*\.[a-z]{2,}$/,
                                                message: 'Please enter a valid email'
                                            }
                                        })}
                                    />
                                    {errors.useremail ? <FormErrorMessageSpan style={{ marginTop: "2px", marginBottom: "10px" }}>{errors.useremail.message}</FormErrorMessageSpan> : null}
                                </FormField> : null}
                                {signinStep === 'confirmpassword' || signinStep === 'updatepassword' ? <FormField>
                                    <input
                                        name='otp'
                                        type="text"
                                        placeholder="6 digit OTP"
                                        minLength={6}
                                        maxLength={6}
                                        ref={register({ required: "Please enter OTP" })}
                                    />
                                    {errors.otp ? <FormErrorMessageSpan style={{ marginTop: "2px", marginBottom: "10px" }}>{errors.otp.message}</FormErrorMessageSpan> : null}
                                </FormField> : null}
                                {signinStep === 'confirmpassword' || signinStep === 'updatepassword' ? <FormField>
                                    <input
                                        name='userpassword'
                                        type="password"
                                        placeholder="Enter Password"
                                        onChange={() => setPasswordNotMatch(false)}
                                        ref={register({ required: "Please enter new password" })}
                                    />
                                    {errors.userpassword ? <FormErrorMessageSpan style={{ marginTop: "2px", marginBottom: "10px" }}>{errors.userpassword.message}</FormErrorMessageSpan> : null}
                                </FormField> : null}
                                {signinStep === 'confirmpassword' || signinStep === 'updatepassword' ? <FormField>
                                    <input
                                        name='userconfirmpassword'
                                        type="password"
                                        onChange={() => setPasswordNotMatch(false)}
                                        ref={register({ required: "Please re-enter password" })}
                                        placeholder="Re-enter password"
                                    />
                                    {errors.userconfirmpassword ? <FormErrorMessageSpan style={{ marginTop: "2px", marginBottom: "10px" }}>{errors.userconfirmpassword.message}</FormErrorMessageSpan> : null}
                                    {passwordNotMatch ? <FormErrorMessageSpan style={{ marginTop: "2px", marginBottom: "10px" }}>Please enter same password</FormErrorMessageSpan> : null}
                                </FormField> : null}

                                {signinStep === 'multipleUsers' ? <div>
                                    {currentUserDetails?.length && currentUserDetails?.map((userData:any)=> (<LoginCustomerRadio
                                        name="loginUser"
                                        label=''
                                        value={userData?.tokenInfo?.user?.encryptedId}
                                        userData={userData?.tokenInfo?.user}
                                        radiobuttonRef={register({
                                            required: "Please select the user.",
                                        })}
                                    ></LoginCustomerRadio>))}
                                </div> : null}
                                {
                                    signinStep === 'multipleUsers' ? <LoginSuccessBtn isMobile={isMobile} type="button" disabled={!formState.isValid} onClick={onUserSelection}>Continue with this account</LoginSuccessBtn> :
                                        <LoginSuccessBtn isMobile={isMobile} type="submit" disabled={!formState.isValid || passwordNotMatch}>Submit</LoginSuccessBtn>
                                }
                            </form>
                        </LoginFormContainer>

                        {signinStep === 'mobile' ? <LoginToolbox isMobile={isMobile}>
                            Your details are kept private and we never spam.<br />
                            <span>Learn about
                                <ClickableSpan onClick={() => redirectToOld('privacy-policy', !isMobile)} style={{ color: isMobile ? COLOR.BLACK : '#236df1' }}>&nbsp;Privacy</ClickableSpan> &#38;
                                <ClickableSpan onClick={() => redirectToOld('terms-conditions', !isMobile)} style={{ color: isMobile ? COLOR.BLACK : '#236df1' }}>&nbsp;Terms</ClickableSpan>
                            </span>
                        </LoginToolbox> : null}
                        {(signinStep === 'password' && !userPasswordNotPresent) ? <LoginToolbox isMobile={isMobile}>
                            <ClickableSpan style={{ float: 'left', color: isMobile ? COLOR.BLACK : '#236df1', paddingBottom: isMobile ? "" : "25px" }} onClick={onForgetPasswordClick}>Forgot Password?</ClickableSpan>
                            <ClickableSpan style={{ float: 'right', color: isMobile ? COLOR.BLACK : '#236df1', paddingBottom: isMobile ? "" : "25px" }} onClick={() => { dispatch(LoginActions.setSigninStep('mobile')); setValue('mobile', '') }}>Entered Wrong Mobile?</ClickableSpan>
                        </LoginToolbox> : null}
                        {signinStep === 'userdetails' ? <LoginToolbox isMobile={isMobile}>
                            <ClickableSpan style={{ float: 'right', color: isMobile ? COLOR.BLACK : '#236df1', paddingBottom: isMobile ? "" : "25px" }} onClick={() => { dispatch(LoginActions.setSigninStep('mobile')); setValue('mobile', '') }}>Entered Wrong Mobile?</ClickableSpan>
                        </LoginToolbox> : null}
                        {signinStep === 'confirmpassword' || signinStep === 'updatepassword' ? <LoginToolbox isMobile={isMobile}>
                            <ClickableSpan style={{ float: 'left', color: isMobile ? COLOR.BLACK : '#236df1', paddingBottom: isMobile ? "" : "25px" }} onClick={resendOtp}>Resend OTP?</ClickableSpan>
                            <ClickableSpan style={{ float: 'right', color: isMobile ? COLOR.BLACK : '#236df1', paddingBottom: isMobile ? "" : "25px" }} onClick={() => { dispatch(LoginActions.setSigninStep('mobile')); setValue('mobile', '') }}>Entered Wrong Mobile?</ClickableSpan>
                        </LoginToolbox> : null}

                    </section>
                </LoginContDiv>
            </LoginOuterCont>
        </LargePopup>
    </LoginMainContDiv>)
}

export default Login;